<template>
  <div>
    <v-card class="mx-auto mt-2">
      <v-skeleton-loader
        class="mx-auto"
        type="table-thead, table-tbody"
        v-if="isListLoading && audioList.length === 0"
      />
      <v-data-table
        v-else
        :headers="headers"
        :items="audioList"
        :options.sync="options"
        :loading="isListLoading"
        :server-items-length="audioList.length"
        no-data-text="لا يوجد بيانات .."
        hide-default-footer
        group-by="folderName"
      >
        <template v-slot:top>
          <v-toolbar flat class="" min-height-sm="200">
            <v-row align="center">
              <v-col cols="6" md="3" class="py-0">
                <h2>قائمة تسجيلات الراديو</h2>
              </v-col>
              <v-spacer />
              <v-col cols="6" md="3" class="py-0 text-left">
                <v-btn
                  color="primary"
                  :to="{ name: 'recordings.new', query: $route.query }"
                >
                  جديد +
                </v-btn>
              </v-col>
            </v-row>
          </v-toolbar>
        </template>

        <template v-slot:group.header="{ items, isOpen, toggle }">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="10">
                <v-btn icon @click="toggle">
                  <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
                {{ items[0].folderName }}
              </v-col>
              <v-col>
                <span class="px-4"></span>
                <v-tooltip>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      fab
                      x-small
                      color="error"
                      class="mx-3"
                      v-on="on"
                      :loading="
                        deleteLoading && folderId === items[0].folderName
                      "
                      @click.prevent="onDeleteFolder(items[0].folderName)"
                    >
                      <v-icon>mdi-delete-forever</v-icon>
                    </v-btn>
                  </template>
                  <span>حذف المجلد</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </td>
        </template>
        <template v-slot:item.name="{ item }">
          {{ item.name }}
        </template>
        <template v-slot:item.plays="{ item }">
          {{ item.plays }}
        </template>
        <template v-slot:item.options="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                fab
                x-small
                color="white"
                class="mx-2"
                v-on="on"
                :loading="deleteLoading && documentId === item.id"
                @click.prevent="onDeleteAudio(item)"
              >
                <v-icon color="red">mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>حذف</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <router-view />
  </div>
</template>


<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      options: {},
      documentId: null,
      folderId: null,
    };
  },
  metaInfo() {
    return { title: "تسجيلات الراديو" };
  },
  mounted() {
    this.$store.commit("SET_BREADCRUMBS", this.breadcrumbsItems);
    this.onFetchAudiosList();
  },
  computed: {
    ...mapState("recordings", ["audioList", "isListLoading", "deleteLoading"]),
    breadcrumbsItems() {
      return [{ text: "الرئيسية", name: "home" }, { text: "تسجيلات الراديو" }];
    },
    headers() {
      return [
        {
          text: "إسم الصوتية",
          value: "name",
          align: "right",
        },
        {
          text: "عدد التحميلات",
          value: "plays",
          align: "center",
        },
        {
          text: "الخيارات",
          value: "options",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    async onFetchAudiosList() {
      await this.$store.dispatch("recordings/onFetchAudiosList");
    },
    async onDeleteAudio(audio) {
      this.documentId = audio.id;
      const confirmation = await this.$store.dispatch("confirm/ask", {
        title: "تأكيد الحذف",
        body: "هل أنت متأكد من انك تريد حذف هذا العنصر ؟",
      });
      if (confirmation) {
        await this.$store.dispatch("recordings/onDeleteAudio", audio);
        this.documentId = null;
      }
    },
    async onDeleteFolder(folderName) {
      this.folderId = folderName;
      const confirmation = await this.$store.dispatch("confirm/ask", {
        title: "تأكيد الحذف",
        body: "هل أنت متأكد من انك تريد حذف المجلد بالكامل ؟",
      });
      if (confirmation) {
        await this.$store.dispatch("recordings/onDeleteFolder", folderName);
        this.folderId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>